export enum StoreExperienceTypes {
    ADD_TO_CART = 'Add to Cart', // Marketplace products
    REQUEST_INFORMATION = 'Request Information', // Showroom product when partner has accepted data sharing terms
    VIEW_ONLY = 'View Only', // Showroom product when partner has not accepted data sharing terms
    UNKNOWN = 'Unknown', // Unknown product experience type
}
